module.exports = __webpack_public_path__ + "static/media/Weight.f5e6a0e8.svg";